import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';
import Select from '~/components/Form/Select';
import Load from '~/components/Load';

import { Container } from './styles';

export default function UsersNew() {
  const inputRef = useRef(null);
  const [times, setTimes] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [carregar, setCarregar] = useState(false);
  const user = useSelector(state => state.user.profile);

  useEffect(() => {
    async function getTimes() {
      setLoading(true);
      const response = await api.get('/times-select');
      const data = response.data.map(time => ({
        value: time.id,
        label: time.name,
      }));

      setTimes(data);
      setLoading(false);
    }
    async function getCargos() {
      let data = [];
      if (user.provider === '2') {
        data = [
          {
            value: 1,
            label: 'Gerente',
          },
          {
            value: 3,
            label: 'Normal',
          },
        ];
      } else if (user.provider === '4') {
        data = [
          {
            value: 1,
            label: 'Gerente',
          },
          {
            value: 2,
            label: 'Diretor',
          },
          {
            value: 3,
            label: 'Normal',
          },
          {
            value: 4,
            label: 'Bamboo',
          },
        ];
      }

      setCargos(data);
    }
    getTimes();
    getCargos();
  }, [user.provider]);

  /**
   * Funcoes
   */

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      let schema;

      if (user.provider === '4') {
        schema = Yup.object().shape({
          time_id: Yup.string('Selecione um time').required(
            'Selecione um time'
          ),
          name: Yup.string().required('Preencha o campo nome'),
          email: Yup.string()
            .email('Preencha um e-mail valido')
            .required('Preencha o campo e-mail'),
          password: Yup.string()
            .required('Preencha o campo senha')
            .min(6, 'Senha precisa ter no minimo 6 caracteres'),
          provider: Yup.string('Selecione um cargo').required(
            'Selecione um cargo'
          ),
          hora_abertura: Yup.string().required(
            'Preencha o campo hora de entrada do usuario'
          ),
          hora_encerramento: Yup.string().required(
            'Preencha o campo hora de saida do usuario'
          ),
        });
      } else {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
          email: Yup.string()
            .email('Preencha um e-mail valido')
            .required('Preencha o campo e-mail'),
          password: Yup.string()
            .required('Preencha o campo senha')
            .min(6, 'Senha precisa ter no minimo 6 caracteres'),
          provider: Yup.string('Selecione um cargo').required(
            'Selecione um cargo'
          ),
          hora_abertura: Yup.string().required(
            'Preencha o campo hora de entrada do usuario'
          ),
          hora_encerramento: Yup.string().required(
            'Preencha o campo hora de saida do usuario'
          ),
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      const timeId = user.provider === '4' ? data.time_id : user.time_id;

      await api.post('/user', {
        time_id: timeId,
        name: data.name,
        email: data.email,
        password: data.password,
        provider: data.provider,
        hora_abertura: data.hora_abertura,
        hora_encerramento: data.hora_encerramento,
      });

      toast.success('Usuario cadastrado com sucesso');
      history.push('/user');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o usuario, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Cadastrar Usuário</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input icon="MdPerson" label="Nome" name="name" type="text" />
          <Input icon="MdMail" label="E-mail" name="email" type="text" />
          <Input icon="MdLock" label="Senha" name="password" type="password" />
          {user.provider !== '1' && user.provider !== '3' && (
            <>
              <Select name="time_id" labelSelect="Times" options={times} />
              <Select name="provider" labelSelect="Cargo" options={cargos} />
            </>
          )}
          <Input
            icon="MdAccessTime"
            label="Hora de entrada do usuario"
            name="hora_abertura"
            type="time"
          />
          <Input
            icon="MdAccessTime"
            label="Hora de saida do usuario"
            name="hora_encerramento"
            type="time"
          />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
